<!-- po-approve-reject-page.component.html -->

<div class="custom-margin">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="text-center mt-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading PO details...</p>
  </div>

  <!-- Main Content -->
  <section class="section-card" *ngIf="!isLoading && poData.po_id" id="content-to-pdf">
    
    <!-- Header -->
    <div class="row">
      <div class="col-md-12">
        <div class="headingPara">
          <h5>#{{poData.poCode}}</h5>
          <span class="badge copexOpexButtons">{{poData.poType || 'PO'}}</span>
          <span class="badge" [ngClass]="getStatusBadge(poData.poStatus || poData.poCategoryStatus)">
            {{poData.poStatus || poData.poCategoryStatus || 'Pending'}}
          </span>
          <span *ngIf="isReadOnly" class="badge badge-secondary ms-2">View Only</span>
        </div>
      </div>
    </div>

    <!-- Company & PO Details -->
    <div class="row mt-4">
      <div class="col-md-6">
        <div class="form-group side_pad">
          <div class="container-fluid">
            <a class="navbar-brand mt-2 mt-lg-0">
              <img src="assets/logo/EMP.png" height="80" alt="EM_Procurement" loading="lazy" />
            </a><br>
            <span>
              Affiliated with <strong>FIH, AHF & IOA</strong><br>
              Recognised by <strong>MYAS, Govt.of India</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="grn_score_data">
          <br>
          <div class="row">
            <div class="col-md-12">
              <span class="grn_score">Telephone:</span> {{poData.phoneNo || poData.contactNo || 'N/A'}}<br>
              <span class="grn_score">Email:</span> 
              <a [href]="'mailto:' + (poData.mailId || poData.emailId)">{{poData.mailId || poData.emailId || 'N/A'}}</a><br>
              <span class="grn_score">Address:</span> {{poData.address || poData.billingAddress || 'N/A'}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PO Description -->
    <div class="row mt-4">
      <div class="col-md-12">
        <textarea class="form-control" disabled rows="3">
          {{ stripHtmlTags(poData?.poHeadDescription) }}
        </textarea>
      </div>
    </div>

    <!-- PO Items Table -->
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="head">PO Items</div>
        <div class="table-responsive mt-2">
          <table class="table table-bordered">
            <thead class="table-dark">
              <tr>
                <th>S.No</th>
                <th>Supplier Name</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Item Amount</th>
                <th>CGST</th>
                <th>SGST</th>
                <th>IGST</th>
                <th>Additional Charges</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of rowData; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.supplierName || item.vendorName || 'N/A' }}</td>
                <td>{{ item.itemName || 'N/A' }}</td>
                <td>{{ item.quantity || 0 }}</td>
                <td>₹{{ item.itemPrice || 0 | number:'1.2-2' }}</td>
                <td>{{ item.CGST || 0 }}%</td>
                <td>{{ item.SGST || 0 }}%</td>
                <td>{{ item.IGST || 0 }}%</td>
                <td>₹{{ item.additionalCharge || 0 | number:'1.2-2' }}</td>
                <td>₹{{ (item.priceIncludingCharges || (item.quantity * item.itemPrice)) | number:'1.2-2' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-active fw-bold">
                <td colspan="9" class="text-end">Net Amount:</td>
                <td>₹{{ poTotalAmount | number:'1.2-2' }}</td>
              </tr>
              <tr class="table-info fw-bold" *ngIf="poData?.advancepaymentammount">
                <td colspan="9" class="text-end" style="color: #004774;">Advance Payment ({{ poData?.advancePaymentPercentage }}%):</td>
                <td style="color: #004774;">₹{{ poData?.advancepaymentammount | number:'1.2-2' }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <!-- Delivery Address -->
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="head">Product Delivery Location</div>
        <div class="table-responsive mt-2">
          <table class="table table-bordered">
            <thead class="table-dark">
              <tr>
                <th>S.No</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Delivery Address</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of tentativeData; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.itemName || 'N/A' }}</td>
                <td>{{ item.quantity || 0 }}</td>
                <td>{{ item.deliveryAddress || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Milestone Details -->
    <div *ngIf="isMilestoneRequired && poMilestoneData.length > 0">
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="head">PO Milestone Details</div>
          <div class="table-responsive mt-2">
            <table class="table table-bordered">
              <thead class="table-dark">
                <tr>
                  <th>S.No</th>
                  <th>Milestone</th>
                  <th>Type</th>
                  <th>Due Date</th>
                  <th>Pay %</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of poMilestoneData; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ row.milestoneName }}</td>
                  <td>{{ row.type }}</td>
                  <td>{{ row.dueDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ row.payPercent }}%</td>
                  <td>
                    <span class="badge" [ngClass]="{
                      'bg-warning': row.status === 'Pending',
                      'bg-success': row.status === 'Completed',
                      'bg-danger': row.status === 'Rejected'
                    }">{{ row.status || 'Pending' }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Signature -->
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="head">Signature</div>
        <div class="mt-2">
          <div *ngIf="poData?.signature" class="pdf-preview">
            <img [src]="poData.signature" alt="Signature" width="200" height="75">
          </div>
          <p *ngIf="!poData?.signature" class="text-muted">No signature available</p>
        </div>
      </div>
    </div>

    <!-- Terms & Conditions -->
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="head">Terms & Conditions</div>
        <textarea class="form-control mt-2" disabled rows="3">
          {{ stripHtmlTags(poData?.termsAndCondition_Description) }}
        </textarea>
      </div>
    </div>

    <!-- Payment Terms -->
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="head">Payment Terms</div>
        <textarea class="form-control mt-2" disabled rows="3">
          {{ stripHtmlTags(poData?.paymentTermsDescription) }}
        </textarea>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="row mt-4">
      <div class="col-md-12 text-end">
        <button class="btn btn-secondary me-2" (click)="downloadPDF()">
          <i class="fas fa-print"></i> Print
        </button>
        <button class="btn btn-danger me-2" (click)="openRemarkPopup('Rejected')" [disabled]="isReadOnly">
          <i class="fa-solid fa-times"></i> Reject
        </button>
        <button class="btn btn-success" (click)="openRemarkPopup('Approved')" [disabled]="isReadOnly">
          <i class="fa-solid fa-check"></i> Approve
        </button>
      </div>
    </div>

    <!-- Back Button -->
    <div class="row mt-4">
      <div class="col-md-12">
        <button class="btn btn-secondary" (click)="goBack()">
          <i class="fa-solid fa-arrow-left"></i> Back
        </button>
      </div>
    </div>

  </section>

  <!-- Not Found -->
  <div *ngIf="!isLoading && !poData.po_id" class="text-center mt-5">
    <div class="alert alert-danger">
      <h4>PO Not Found</h4>
      <p>The Purchase Order you are looking for does not exist or has been removed.</p>
      <button class="btn btn-primary mt-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i> Go Back
      </button>
    </div>
  </div>
</div>